import { Popup, Table } from 'semantic-ui-react';
import { Button, Icon } from '@britishcouncil/react-admin';
import styled from '@emotion/styled';
import { LinkedSpeakingSessionDto } from 'api/planning';
import { generatePath, Link } from 'react-router';
import { ROUTING_PATHS } from 'const';

type Props = {
  linkedSpeakingSession: LinkedSpeakingSessionDto;
  canUnlinkSpeakingSession: boolean;
  openUnlinkModal: (speakingSessionId: number) => void;
};

export const SpeakingSessionRow = ({
  linkedSpeakingSession,
  canUnlinkSpeakingSession,
  openUnlinkModal,
}: Props) => {
  const { speakingSessionDetails } = ROUTING_PATHS;

  const canUnlink = canUnlinkSpeakingSession && linkedSpeakingSession.bookedSharedSeats === 0;

  return (
    <Table.Row key={linkedSpeakingSession.id}>
      <Table.Cell>{linkedSpeakingSession.date}</Table.Cell>
      <Table.Cell>{linkedSpeakingSession.venueName}</Table.Cell>
      <Table.Cell>{linkedSpeakingSession.plannedSlots}</Table.Cell>
      <Table.Cell>{linkedSpeakingSession.availableSlots}</Table.Cell>
      <Table.Cell>
        <S.Registrations>
          <Popup
            content={
              <span>
                {linkedSpeakingSession.bookedSharedSeats} - registrations from this session <br />
                {linkedSpeakingSession.bookedSpeakingSlots} - total (including all LRWS & OSR-S
                registrations)
              </span>
            }
            trigger={
              <div>
                {linkedSpeakingSession.bookedSharedSeats} |{' '}
                {linkedSpeakingSession.bookedSpeakingSlots}
              </div>
            }
            inverted
            position="bottom center"
            flowing
          />
        </S.Registrations>
      </Table.Cell>
      <Table.Cell>
        <Link
          to={generatePath(speakingSessionDetails.absolutePath, {
            sessionId: linkedSpeakingSession.id,
          })}
        >
          <Button primary opaque compact>
            View
            <S.Icon name="external square" />
          </Button>
        </Link>
        {canUnlink && (
          <Button opaque compact onClick={() => openUnlinkModal(linkedSpeakingSession.id)}>
            <S.Icon name="broken chain" color="red" />
          </Button>
        )}
      </Table.Cell>
    </Table.Row>
  );
};

const S = {
  Icon: styled(Icon)`
    .ui.button > i&.external.square.icon {
      margin: 0;
      margin-left: 0.5rem;
    }
  `,
  Registrations: styled(Table.Cell)`
    background-color: #dfe0e0;
    font-weight: 600;
    border-radius: 25px;
    padding: 5px;
  `,
};
